import Parse from "parse";

import type { _User } from "./_User";
import type { SIV_DeliveryNotes } from "./SIV_DeliveryNotes";
import type { SIV_GoodsReceiptProcessPosition } from "./SIV_GoodsReceiptProcessPosition";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_GoodsReceiptProcessPositionDeliveryNoteAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  changedBy?: _User | undefined;
  date?: Date | undefined;
  deliveryNote: SIV_DeliveryNotes;
  goodsReceiptProcessPosition?: SIV_GoodsReceiptProcessPosition | undefined;
  notFoundValues: any;
  quantity?: number | undefined;
  tenant: OD3_Tenant;
}

export class SIV_GoodsReceiptProcessPositionDeliveryNote extends Parse.Object<SIV_GoodsReceiptProcessPositionDeliveryNoteAttributes> {
  static className: string = "SIV_GoodsReceiptProcessPositionDeliveryNote";

  constructor(
    data?: Partial<SIV_GoodsReceiptProcessPositionDeliveryNoteAttributes>,
  ) {
    super(
      "SIV_GoodsReceiptProcessPositionDeliveryNote",
      data as SIV_GoodsReceiptProcessPositionDeliveryNoteAttributes,
    );
  }

  get changedBy(): _User | undefined {
    return super.get("changedBy");
  }
  set changedBy(value: _User | undefined) {
    super.set("changedBy", value);
  }

  get date(): Date | undefined {
    return super.get("date");
  }
  set date(value: Date | undefined) {
    super.set("date", value);
  }

  get deliveryNote(): SIV_DeliveryNotes {
    return super.get("deliveryNote");
  }
  set deliveryNote(value: SIV_DeliveryNotes) {
    super.set("deliveryNote", value);
  }

  get goodsReceiptProcessPosition():
    | SIV_GoodsReceiptProcessPosition
    | undefined {
    return super.get("goodsReceiptProcessPosition");
  }
  set goodsReceiptProcessPosition(
    value: SIV_GoodsReceiptProcessPosition | undefined,
  ) {
    super.set("goodsReceiptProcessPosition", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get quantity(): number | undefined {
    return super.get("quantity");
  }
  set quantity(value: number | undefined) {
    super.set("quantity", value);
  }

  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass(
  "SIV_GoodsReceiptProcessPositionDeliveryNote",
  SIV_GoodsReceiptProcessPositionDeliveryNote,
);
